<template>
  <div>
    <header id="blog-header">
      <div class="inner ">
        <!--<slot name="headContent"></slot>-->
      </div>
    </header>
    <author-info
      :suggestions="suggestions"
      :keyword.sync="searchKeyword"
      @search="handleSearch"
    ></author-info>
    <all-blogposts :func="func">
    </all-blogposts>
  </div>
</template>

<script>
import allBlogposts from './AllBlogPosts'
import AuthorInfo from './layout/components/AuthorInfo'
import { fetchSearchSuggestions } from '../utils/search'
export default {
  name: 'profile',
  components: {
    allBlogposts,
    AuthorInfo
  },
  data () {
    return {
      blogpostsnum: this.$store.state.blogpostsnum,
      func: 'profile',
      searchKeyword: '',
      suggestions: []
    }
  },
  created () {
    this.loadSuggestions()
  },
  mounted () {
  },
  methods: {
    async loadSuggestions () {
      this.suggestions = await fetchSearchSuggestions(this.$http, this.$store.state.baseUrl)
    },
    handleSearch (query) {
      const trimmed = (query || '').trim()
      this.searchKeyword = trimmed
      if (!trimmed) {
        this.$router.push({ name: 'search' })
        return
      }
      this.$router.push({
        name: 'search',
        query: {
          q: trimmed,
          page: 1
        }
      })
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
    }
  }
}
</script>

<style scoped>
  /*@import "../assets/css/gfm.css";*/

#blog-author .post-author {
  padding-bottom: 0em;
}

</style>
